// import { useRouter } from 'vue-router';
import { reactive, ref } from 'vue';
import { v1 as uuid } from 'uuid'
import { useRouterCacheStore } from '../store/RouterCacheStore';
import { getRoutePath, getRoutes } from './RouterMap';
import ViewState from '../viewmodule/ViewState';
import { ElMessage } from "element-plus";
import { getRelatedInfo } from '../datamodule/DataField';
import { getUrlParams, getUrlPath } from '../tools/URLTools';
import { usePermissions } from '../store/Permissions';
import axios from 'axios';
let r = null;
const ROUTER_MAP = new Map();
const LOADED_ROUTERS = new Map();
const GLOBAL_ROUTE_CACHE = ref([]);
const INSTANCE_CACHE = ref([]);
const ROUTE_CACHE = ref([]);
const PROMISE_CACHE = ref([]);
const GLOBAL_ROUTE_ITEM = ref({ path: null, name: null });
const getRouteCache = () => {
    const routeCache = [];
    GLOBAL_ROUTE_CACHE.value.forEach((routeInstance, index) => {
        if (routeInstance.fromName) routeCache.push(routeInstance.fromName);
    })
    return routeCache;
}
export async function loadMap(router, routes) {
    r = router;
    ROUTER_MAP.clear();
    const routeData = getRoutes().concat(routes[0].children).concat(routes[1].children).concat(routes[2].children).concat(routes)
    for (const data of routeData) {
        ROUTER_MAP.set(data.path, {component:data.component, parent:data.parent,meta:data.meta||{}});
    }
}
function getRoute(path, home) {
    // const Permissions = usePermissions().Permissions;
    // const map = {}
    // Permissions.forEach(it => {
    //     map[it] = 1
    // })
    // if(!map[path]){
    //     ElMessage.error('暂无权限')
    //     return
    // }
    axios.get('version.json').then(res => {
        console.log('%c' + '版本信息：' + res.data.version, 'color:blue')
    })
    const cp = path.replace(/\/_[^\/\?]*/, '');
    let route = LOADED_ROUTERS.get(path);
    if (!route) {
        const rt = ROUTER_MAP.get(cp);
        console.log(rt)
        const component = rt.component;
        if (!component) {
            return;
        }
        // let com = !!component.__asyncLoader() ? null : component;
        const name = uuid();
        let c = null;
        if (typeof (component) == 'function') {
            c = async function () {
                const p = await component()
                p.default.name = name;
                return p;
            }
        } else {
            c = ((name) => async function () {
                const p = Object.assign({}, await component.__asyncLoader());
                p.__name = name;
                return p;
            })(name)
        }
        route = { path: path, name: name, component: c };
        if(rt&&rt.meta){
            route.meta = rt.meta
        }
        LOADED_ROUTERS.set(path, route);
        const rs = r.getRoutes();
        let find = false;
        for (const ra of rs) {
            if (ra.path == path) {
                ra.name = name;
                find = true;
                break;
            }
        }
        if (!find) r.addRoute(home || rt.parent || 'Home', route);
    }
    return route;
}
const clearRouteCache = () => {
    const cache = GLOBAL_ROUTE_CACHE.value;
    cache.forEach((routeInstance, index) => {
        routeInstance.resolve(null);
    })
    GLOBAL_ROUTE_CACHE.value = [];
    GLOBAL_ROUTE_ITEM.value = { path: null, name: null };
}
export const testRoute = (path) => {
    const route = LOADED_ROUTERS.get(path);
    return route && !route.check;
}
export const checkRoute = (path, query)=> {
    if (path == '/') return;
    const route = getRoute(path);
    if (!route) return;
    route.check = true;
    GLOBAL_ROUTE_ITEM.value = { path: path, name: route.name };
    r.push({ name: route.name, query: query });
}
export const goto = (path, query) => {
    const route = getRoute(path);
    if (!route) return;
    route.check = false;
    clearRouteCache();
    GLOBAL_ROUTE_ITEM.value = { path: path, name: route.name };
    r.push({ name: route.name, query: query });
    const store = useRouterCacheStore();
    store.update(getRouteCache());
}
export async function enter(module, key, viewState, extData, ro) {
    let mcode = null;
    module.replace(/^(\w+)/, ($0, $1)=> {
        mcode = $1;
    })
    if (!/\.\w+$/.test(module)) module = module + '.id';
    const moduleInfo = getRelatedInfo(module);
    const m = moduleInfo.module;
    if (!m) return;
    let data = null;
    if (key != '' && key != null) {
        data = m.getDataLocal(key, moduleInfo.field.getCode());
        if (!data) data = await m.getByKey(key, moduleInfo.field.getCode());
    } else {
        data = extData;
    }
    if (!viewState) viewState = ViewState.VIEW;
    // INSTANCE_CACHE.value.push(context || null);
    const path = getRoutePath(mcode || m.getCode(), data, ViewState.getViewMode(viewState));
    if (!path) return;
    const route = getRoute(path.replace(/\/\:.*$/, ''));
    if (!route) return;
    let name = r.currentRoute.value.name;
    console.log(r.currentRoute.value)
    if (ROUTE_CACHE.value.indexOf(name) < 0) ROUTE_CACHE.value.push(name);
    const store = useRouterCacheStore();
    console.log(ROUTE_CACHE.value)
    store.update(ROUTE_CACHE.value);
    r.push({ name: route.name, query: { token: btoa(module + ':' + key), state: viewState, route: ro }, state: { ext: extData } });
    const p = new Promise((resolve) => {
        PROMISE_CACHE.value.push(resolve);
    })
    return p;
}
export function replace(module, key, viewState, extData) {
    let mcode = null;
    module.replace(/^(\w+)/, ($0, $1)=> {
        mcode = $1;
    })
    if (!/\.\w+$/.test(module)) module = module + '.id';
    const moduleInfo = getRelatedInfo(module);
    const m = moduleInfo.module;
    if (!m) return;
    const data = m.getDataLocal(key, moduleInfo.field.getCode());
    if (!viewState) viewState = ViewState.VIEW;
    // INSTANCE_CACHE.value.push(context || null);
    const path = getRoutePath(mcode || m.getCode(), data, ViewState.getViewMode(viewState));
    if (!path) return;
    const route = getRoute(path.replace(/\/\:.*$/, ''));
    if (!route) return;
    r.replace({ name: route.name, query: { token: btoa(module + ':' + key), state: viewState }, state: { ext: extData } });
}
export function enterPath(url, home) {
    // /path?module=&key=&state=
    const params = getUrlParams(url);
    const path = getUrlPath(url);
    if (!path) return;
    const route = getRoute(path.replace(/\/\:.*$/, ''), home);
    if (!route) return;
    let name = r.currentRoute.value.name;
    if (ROUTE_CACHE.value.indexOf(name) < 0) ROUTE_CACHE.value.push(name);
    const store = useRouterCacheStore();
    store.update(ROUTE_CACHE.value);
    r.push({ name: route.name, query: { token: btoa(params.module + ':' + params.key), state: params.state } });
    const p = new Promise((resolve) => {
        PROMISE_CACHE.value.push(resolve);
    })
    return p;
}
export function enterUrl(url, query) {
    const route = getRoute(url);
    if (!route) return;
    let name = r.currentRoute.value.name;
    if (ROUTE_CACHE.value.indexOf(name) < 0) ROUTE_CACHE.value.push(name);
    const store = useRouterCacheStore();
    store.update(ROUTE_CACHE.value);
    r.push({ name: route.name, query:query });
    const p = new Promise((resolve) => {
        PROMISE_CACHE.value.push(resolve);
    })
    return p;
}
export function enterUrlParams(url, query) {
    const route = getRoute(url);
    if (!route) return;
    let name = r.currentRoute.value.name;
    if (ROUTE_CACHE.value.indexOf(name) < 0) ROUTE_CACHE.value.push(name);
    const store = useRouterCacheStore();
    store.update(ROUTE_CACHE.value);
    r.push({ name: route.name, state: {data:JSON.stringify(query)} });
    const p = new Promise((resolve) => {
        PROMISE_CACHE.value.push(resolve);
    })
    return p;
}
export function enterUrlReplaceParams(url, query) {
    const route = getRoute(url);
    if (!route) return;
    let name = r.currentRoute.value.name;
    if (ROUTE_CACHE.value.indexOf(name) < 0) ROUTE_CACHE.value.push(name);
    const store = useRouterCacheStore();
    store.update(ROUTE_CACHE.value);
    r.replace({ name: route.name, state: {data:JSON.stringify(query)} });
    const p = new Promise((resolve) => {
        PROMISE_CACHE.value.push(resolve);
    })
    return p;
}

export function replaceUrl(url, query) {
    const route = getRoute(url);
    if (!route) return;
    let name = r.currentRoute.value.name;
    if (ROUTE_CACHE.value.indexOf(name) < 0) ROUTE_CACHE.value.push(name);
    const store = useRouterCacheStore();
    store.update(ROUTE_CACHE.value);
    r.replace({ name: route.name, query:query });
    const p = new Promise((resolve) => {
        PROMISE_CACHE.value.push(resolve);
    })
    return p;
}
export async function leave() {
    // console.log(r.options.history.state);
    // if (r.options.history.state.back == r.options.history.state.current) r.go(-2);
    // else r.back();
    r.back();
    // console.log(r.options.history.state);
}
export function check(to) {
    const cache = ROUTE_CACHE.value;
    if (cache[cache.length - 1] != to.name) return;
    INSTANCE_CACHE.value.pop();
    (() => {
        setTimeout(() => {
            ROUTE_CACHE.value.pop();
            const store = useRouterCacheStore();
            store.update(ROUTE_CACHE.value);
        }, 0)
    })()
    const resolve = PROMISE_CACHE.value.pop();
    console.log('resolve', resolve)
    if (resolve) resolve('back');
}